module.exports = __webpack_public_path__ + "static/media/rockets.8b789e89.png";